<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Doctor Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Doctor Details",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            doctor: {},
            specializations: [],
            languages: [],
            certificates: [],
            bank_details: [],
            consultations: '',
            online_count: '',
            account_no: '',

            errors: {},
            token: '',

            password: "",
            password_confirmation: "",

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchDoctor();
      },

      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         fetchDoctor() {
            let url = "clinic/doctor/profile?doctor_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.doctor = responseData.doctor;  
               this.specializations = responseData.specializations;
               this.languages = responseData.languages;
               this.certificates = responseData.certificates;
               this.bank_details = responseData.bank_details;
               // this.offline_count = responseData.offline_count;
               this.consultations = responseData.consultations;               
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },     
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <!-- <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a> -->
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        <router-link :to="{ name: 'doctors.schedules', params:{id: $route.params.id, from: 'profile'} }" class="btn btn-primary float-end me-2">Schedules</router-link>
                        <router-link :to="{ name: 'doctors.symptom.questions', params: {doctor_id: doctor.id} }" class="btn btn-primary float-end me-2">Symptoms Questions</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- Details starts -------->
                  <div class="row">
                     <div class=" col-lg-5 col-md-5">
                        <div class="card overflow-hidden">
                           <div class="bg-soft bg-primary">
                              <div class="row m-0">
                                 <div class="col-7">
                                 
                                 </div>
                                 <div class="col-5 align-self-end">
                                    <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                                 </div>
                              </div>
                           </div>
                           <div class="card-body pt-2">
                              <div class="row">
                                 <div class="col-sm-4">
                                    <div class="avatar-md profile-user-wid mb-1">
                                       <img v-if="doctor.image" :src="$image_url + doctor.image" alt
                                       class="img-thumbnail rounded-circle">
                                       <img v-else src="@/assets/images/no-user.jpg"
                                       alt
                                       class="img-thumbnail rounded-circle"
                                       />
                                    </div>
                                    
                                 </div>
                                 <div class="col-sm-8 align-self-center">
                                    <h5 class="font-size-15">
                                       <span v-if="doctor.prefix == 1">Dr.</span><span v-else-if="doctor.prefix == 2">Mr.</span><span v-else-if="doctor.prefix == 3">Ms.</span> {{doctor.name}} {{doctor.qualification}}
                                    </h5>
                                    <p class="font-size-14 mt-3 mb-1">
                                       <i class="bx bx-phone me-1 text-primary"></i> 
                                       {{doctor.country_code}} {{doctor.mobile}}
                                    </p>
                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-envelope me-1 text-primary"></i>
                                       {{doctor.email}}
                                    </p>

                                    <p class="font-size-14 mb-1">
                                       <i class="bx bx-map me-1 text-primary"></i>
                                       {{doctor.address}}
                                    </p>
                                 </div>
                              </div>                              

                           </div>
                        </div>
                        <!-- end card -->     
                        <!-- <div class="d-grid gap-2">
                           <b-button v-b-modal.password-modal block variant="outline-primary">Change Password</b-button>
                           
                           <router-link :to="{ name: 'doctors.edit' }" class="btn btn-outline-primary">Edit Profile</router-link>  
                        </div> -->

                        <!-- <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">
                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="bx bx-desktop font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Online Consultations</p>
                                 <h4 class="mb-0">50</h4>
                              </div>

                              
                           </div>
                        </b-card> -->

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">                           
                           <div class="media">

                              <div class="avatar-sm align-self-center me-4 rounded-circle bg-primary">
                                 <span class="avatar-title">
                                    <i class="fas fa-clinic-medical font-size-24"></i>
                                 </span>
                              </div>
                              <div class="media-body">
                                 <p class="text-muted fw-medium mb-2">Consultations</p>
                                 <h4 class="mb-0">{{consultations}}</h4>
                              </div>

                             
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>
                           <li class="mb-3">
                              <a :href="$image_url + doctor.id_proof" target="_blank">
                                    <img :src="$image_url + doctor.id_proof" alt="ID Proof" style="max-width: 100px;">
                              </a>
                           </li>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light mt-3">  
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Certificates</h4>
                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3" v-for="(certificate) in certificates" :key="certificate.id">
                                 <a :href="$image_url + certificate.certificate" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a>  
                              </li>
                           </ul>
                        </b-card>

                     </div>

                     <div class="col-lg-7 col-md-7">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Doctor Details</h4>
                              

                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>
                                       
                                       <tr>
                                          <th width="45%">Gender</th>
                                          <th width="5%">:</th>
                                          <td width="50%">
                                             <span v-if="doctor.gender==1">Male</span>
                                             <span v-if="doctor.gender==2">Female</span>
                                             <span v-if="doctor.gender==3">Others</span>
                                          </td>
                                       </tr> 

                                       <tr>
                                          <th>D.O.B</th>
                                          <th>:</th>
                                         <td>{{doctor.dob | formatDate}}</td>
                                       </tr>

                                          <tr>
                                          <th>Age</th>
                                          <th>:</th>
                                         <td>{{doctor.age}}</td>
                                       </tr>

                                       <!-- <tr>
                                          <th>Current Hospital</th>
                                          <th>:</th>
                                          <td>St James,Pala</td>
                                       </tr> -->

                                       <tr>
                                          <th>Specializations</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(specialization, index) in specializations" :key="specialization.id">
                                                {{ specialization.specialization }}
                                                <span v-if="index < specializations.length - 1">,</span>
                                             </span>                                             </td>
                                       </tr>     

                                       <tr>
                                          <th>Languages</th>
                                          <th>:</th>
                                          <td>
                                             <span v-for="(language, index) in languages" :key="language.id">
                                                {{language.language}}
                                                <span v-if="index < languages.length - 1">,</span>
                                             </span>                                          </td>
                                       </tr> 
                                       <!-- <tr>
                                          <th>Commision</th>
                                          <th>:</th>
                                          <td>100</td>
                                       </tr> 
                                       <tr>
                                          <th>Created On</th>
                                          <th>:</th>
                                          <td>20 Oct 2021, 6:30pm</td>
                                       </tr>    -->
                                         
                                    </tbody>
                                 </table>
                              </div>
                           
                        </b-card>
                        <!-- end card -->

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>                            
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody>                                       
                                       <tr>
                                          <th width="45%">Reg. No</th>
                                          <th width="5%">:</th>
                                          <td>{{doctor.reg_no}}</td>
                                       </tr>               
                                       
                                       <tr>
                                          <th>Reg. Council</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_council}}</td>
                                       </tr>

                                       <tr>
                                          <th>Reg. Date:</th>
                                          <th>:</th>
                                          <td>{{doctor.reg_date | formatDate}}</td>
                                       </tr>     
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>
                              <div class="table-responsive ">
                                 <table class="table table-nowrap mb-0">
                                    <tbody> 

                                       <tr>
                                          <th width="45%">Account No</th>
                                          <th width="5%">:</th>
                                          <td><span v-if="bank_details.length > 0 && bank_details[0].account_no">{{ bank_details[0].account_no }}</span> </td>                                     
                                       </tr>

                                       <tr>
                                          <th>Account Holder Name</th>
                                          <th>:</th>
                                          <td><span v-if="bank_details.length > 0 && bank_details[0].account_holder_name">{{ bank_details[0].account_holder_name }}</span></td>
                                       </tr>          
                                       
                                       <tr>
                                          <th>IFSC Code</th>
                                          <th>:</th>
                                          <td><span v-if="bank_details.length > 0 && bank_details[0].ifsc_code">{{ bank_details[0].ifsc_code }}</span></td>

                                       </tr>

                                       <tr>
                                          <th>UPI ID</th>
                                          <th>:</th>
                                          <td><span v-if="bank_details.length > 0 && bank_details[0].upi_id">{{ bank_details[0].upi_id }}</span></td>

                                       </tr>   
                                    </tbody>
                                 </table>
                              </div>
                        </b-card>

                     </div>
                     
                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="changePassword()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"></b-form-input>

                  
               </b-col>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"></b-form-input>

                  
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
